import { trackCustomEvent } from '@/hooks/client/use-analytics-engine'
import { EventType } from '@/lib/analytics/events'

type DirectoryEvent = 'directory-filter' | 'directory-sort' | 'directory-compare' | 'directory-page'

// Click events for the directory's own controls (filter values, sort, the
// tray's compare action). Clicks are unsampled, so they count 1:1 in
// site_events / PostHog. The legacy add-to-compare event
// (`compare-add-product--click`) is fired separately, unchanged.
export const trackDirectory = (
  event: DirectoryEvent,
  properties: Record<string, string | number | boolean | undefined>
) => trackCustomEvent(`${event}--click`, EventType.Click, properties)
